export enum ManufacturerStatus {
  Normal = 'normal',
  Removed = 'removed',
  Unresolved = 'unresolved'
}

export enum ManufacturerChannel {
  Online = 'online',
  Offline = 'offline'
}

export interface Manufacturer {
  manufacturername?: string;
  description?: string;
  status?: ManufacturerStatus;
  creationdate?: string;
  modificationdate?: string;
  channel?: ManufacturerChannel;
  props: { [name: string]: any };
}

export interface ManufacturerPrice {
  priceid?: number;
  manufacturername?: string;
  pricename?: string;
  description?: string;
  pricevalue?: number;
  discountrate?: number;
  discountdeadline?: string;
  discountstartdate?: string;
}
